import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification, Tooltip } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faThumbsDown, faThumbsUp, faTrash, faEllipsis, faCloudDownload, faBan, faCheckCircle, faExclamationCircle, faRefresh, faMoneyBill, faCoins, faPlus } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list, changeStatus, amountReverse } from "../../../controllers/V1/users/usersController";
import { getPage } from "../../../controllers/common";

import ExportPopup from './Export';
import DueAmountUpdatePopup from './DueAmountUpdatePopup';
import CollectionUpdatePopup from './CollectionUpdatePopup';
import { formatProjectDate } from "../../../controllers/common";
import { usePermissions } from "../../../controllers/PermissionContext";
import ConfirmPopup from "../../../components/ConfirmPopup";
import SelectUsers from "../../../components/SelectUsers";
import { list as generalData } from "../../../controllers/V1/cms/generalDataController";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("usersPermission");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isDueAmountShow, setDueAmountShow] = useState(false);
  const handleDueAmountDrawer = () => setDueAmountShow(!isDueAmountShow);

  const [isCollectionShow, setCollectionShow] = useState(false);
  const handleCollectionDrawer = () => setCollectionShow(!isCollectionShow);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const toggleConfirmPopup = () => setConfirmPopup(!confirmPopup);
  const [reverseID, setReverseID] = useState('');

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [fromDate, setFromDate] = useState(`${moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End
  
  const [filterBindWith, setFilterBindWith] = useState({});
  const [showRequest, setShowRequest] = useState("");
  const [usersType, setUserType] = useState([]);
  const [avlPoints, setAvlPoints] = useState(0);

  let timeoutId;

  const handlePointsChnage = (e) => {
    const value = e.target.value;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setAvlPoints(value);
    }, 2000); 
  }

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'users_name'?{users_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'last_name'?{users_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'users_email'?{users_email : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'users_type'?{users_type : filter?.search }:null),
          ...(filter?.filter_by === 'area'?{area : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'store_name'?{store_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'users_mobile'?{users_mobile : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'pos_number'?{pos_number : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'pos_device_id'?{pos_device_id : filter?.search }:null),
          ...(filter?.filter_by === 'pos_serial_id'?{pos_serial_id : filter?.search }:null),
          ...(filter?.filter_by === 'bind_user_type'?{bind_user_type : filter?.search }:null),
          ...(filter?.filter_by === 'plateform'?{plateform : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'status'?{status : filter?.search }:null),

          ...(filterBindWith && {"bind_person_id" : filterBindWith?.bind_person_id}),

          // ...(filter?.from?{createdAt : {$gte : new Date(`${filter.from} 0:01:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          ...(filter?.from?{createdAt : {$gte : filter.from, $lte : filter.to} }:null),
          ...(showRequest ? { status: showRequest } : null),
          ...(usersType?.length > 0 && {users_type : {$in : usersType}}),
          ...(avlPoints > 0 && {availableArabianPoints : {$lte : parseFloat(avlPoints) || 0}})
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalDataCount(listData?.count);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };


  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      setFromDate("");
      setToDate("");
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
      setFilterBindWith({});
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        // 'to'        : form.get('to_date') || '',
        // 'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }
  
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    console.log('fromDate',fromDate);
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || User's list";
  }, [currentPage, showRequest, filter, LIMIT, usersType, avlPoints]);
  const handleEdit = (items) => {
    navigate('/users/addeditdata', { state: items });
  }

  const handleChangeStatus = async (id = '', status = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else if(!status){
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id, status : status };
        const res = await changeStatus(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `User updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      
    }
  }

  const handleAmountReverse = async ()=>{
    try {
      setIsLoading(true);
      setListData([]);
      if(!reverseID){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
      } else{
        const option = {
          id : reverseID
        }
        const res = await amountReverse(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Amount reverse successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          setIsLoading(false);
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
      setReverseID("");
    } catch (error) {
      setIsLoading(false);
      setReverseID("");
    }
  }

  const handleFilterChange = (e) =>{
      const {name, value} = e.target;
      if(name === 'from_date'){
        setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
      } else if(name === 'to_date'){
        setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
      } else {
        setFilter((pre)=>({
          ...pre,
          [name] : value
        }))
      }
    }

    const getGeneralData = async () => {
      try {
        const res = await generalData();
        if(res?.status === true){
          const { draw_start_time, draw_end_time } = res.result;
          if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
          if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
        }  
      } catch (error) {
        
      }
    }
    useEffect(()=>{
      getGeneralData();
    },[])
  
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"User's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box>
              <div className="inventory_all_tabs users-list-toolbar">
                <div className="users-list-toolbar__top">
                  <div className="all_tabs_value users-list-toolbar__tabs">
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="User list tabs"
                      className="item_tabs_main_container"
                      variant="scrollable"
                      scrollButtons="auto"
                      allowScrollButtonsMobile
                      sx={{
                        minHeight: 42,
                        "& .MuiTab-root": {
                          minHeight: 42,
                          minWidth: "auto",
                          padding: "8px 16px",
                          textTransform: "none",
                          fontWeight: 600,
                          letterSpacing: "0.2px",
                        },
                      }}
                    >
                      <Tab
                        label="All"
                        className="tabs_main_contnet"
                        {...a11yProps(0)}
                        onClick={() => {
                          setUserType([]);
                          setShowRequest('');
                          setSkip(0);
                          setCurrentPage(1);
                        }}
                      />
                      <Tab
                        label="B2B"
                        className="tabs_main_contnet"
                        {...a11yProps(1)}
                        onClick={() => {
                          setUserType(['Retailer','Freelancer','Sales Person','Promoter']);
                          setShowRequest('');
                          setSkip(0);
                          setCurrentPage(1);
                        }}
                      />
                      <Tab
                        label="B2C"
                        className="tabs_main_contnet"
                        {...a11yProps(2)}
                        onClick={() => {
                          setUserType(['Users','tester']);
                          setShowRequest('');
                          setSkip(0);
                          setCurrentPage(1);
                        }}
                      />
                      <Tab
                        label="Deleted"
                        className="tabs_main_contnet"
                        {...a11yProps(3)}
                        onClick={() => {
                          setUserType([]);
                          setShowRequest('D');
                          setSkip(0);
                          setCurrentPage(1);
                        }}
                      />
                    </Tabs>
                  </div>
                  <div className="users-list-toolbar__primary">
                    {(PERMISSION?.addEdit === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                      <button
                        type="button"
                        className="btn btn-dark users-list-toolbar__add"
                        onClick={() => navigate('/users/addeditdata')}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                        <span>Add New</span>
                      </button>
                    )}
                    <Tooltip title="Refresh list">
                      <button
                        type="button"
                        className="users-list-toolbar__icon-btn"
                        onClick={() => getList()}
                        aria-label="Refresh list"
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                      </button>
                    </Tooltip>
                  </div>
                </div>

                <div className="users-list-toolbar__bottom">
                  <div className="users-list-toolbar__group">
                    <div className="users-list-toolbar__field">
                      <FontAwesomeIcon icon={faCoins} className="users-list-toolbar__field-icon" />
                      <input
                        type="number"
                        min="0"
                        name="avlPoints"
                        onChange={handlePointsChnage}
                        placeholder="Points less than…"
                        title="Show users with available points less than this value"
                        aria-label="Available points less than"
                      />
                    </div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>

                  <div className="users-list-toolbar__group">
                    <button
                      type="button"
                      className={`users-list-toolbar__btn${(filter?.search || filter?.filter_by || filterBindWith?.bind_person_id) ? " is-active" : ""}`}
                      onClick={handleFiterDrawer}
                    >
                      <FontAwesomeIcon icon={faFilter} />
                      <span>Filter</span>
                      {(filter?.search || filter?.filter_by || filterBindWith?.bind_person_id) && (
                        <span className="users-list-toolbar__dot" />
                      )}
                    </button>
                    {(PERMISSION?.export === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                      <button
                        type="button"
                        className="users-list-toolbar__btn"
                        onClick={handleExportDrawer}
                      >
                        <FontAwesomeIcon icon={faCloudDownload} />
                        <span>Export</span>
                      </button>
                    )}
                    {(PERMISSION?.dueUpdate === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                      <Tooltip title="Update due amount">
                        <button
                          type="button"
                          className="users-list-toolbar__btn"
                          onClick={handleDueAmountDrawer}
                        >
                          <FontAwesomeIcon icon={faMoneyBill} />
                          <span>Due Amount</span>
                        </button>
                      </Tooltip>
                    )}
                    {(PERMISSION?.collect === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                      <Tooltip title="Update collection">
                        <button
                          type="button"
                          className="users-list-toolbar__btn"
                          onClick={handleCollectionDrawer}
                        >
                          <FontAwesomeIcon icon={faCoins} />
                          <span>Collection</span>
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>User's Type</th>
                              <th>User's Details</th>
                              <th>POS Details</th>
                              <th>Sim No.</th>
                              <th>Bind With</th>
                              <th>Area</th>
                              <th>Available QR-Points</th>
                              <th>Due Amount</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                              <th>Platform</th>
                              <th>Version</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{index + 1}</td>
                                    <td>{items?.users_type}</td>
                                    <td className="admin_user_list_date"> 
                                      <span>{`${items?.users_name} ${items?.last_name}`}</span><br/>
                                      <span>{items?.users_mobile}</span><br/>
                                      {items?.users_email && (<span>{items?.users_email}</span>)}
                                    </td>

                                    {items?.pos_number ? (
                                      <td>
                                        No. : {items.pos_number} <br/>
                                        {items?.pos_serial_id && (`${items.pos_serial_id}`)} <br/>
                                        {items?.pos_serial_id_2 && (`${items.pos_serial_id_2}`)} 
                                      </td>
                                    ):(
                                      <td> N/A </td>
                                    )}

                                    {(items?.sim_serial_no || items?.sim_serial_no_2) ? (
                                      <td>
                                        {items?.sim_serial_no && (`${items?.sim_serial_no}`)} <br/>
                                        {items?.sim_serial_no_2 && (`${items.sim_serial_no_2}`)} 
                                      </td>
                                    ):(
                                      <td> N/A </td>
                                    )}

                                    {items?.bind_person_id ? (
                                      <td>
                                        {items?.bind_person_name} <br/> 
                                        {items?.bind_user_type}
                                      </td>
                                    ):(
                                      <td> N/A </td>
                                    )}
                                    <td className="admin_user_list_date">{items?.area}</td>
                                    <td className="admin_user_list_date">{Math.floor(items?.availableArabianPoints * 100) / 100 || 0}</td>
                                    <td className="admin_user_list_date">{parseFloat(items?.due_amount || 0).toFixed(2)}</td>
                                    <td className="admin_user_list_date">{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A')}</td>
                                    <td className="admin_user_list_date">{items?.status}</td>
                                    <td className="admin_user_list_date">{items?.platform || '-'}</td>
                                    <td className="admin_user_list_date">{items?.version || '-'}</td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {(PERMISSION?.addEdit === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                              <Menu.Item key={`1`} onClick={() => { handleEdit(items) }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Edit</span>
                                              </Menu.Item>
                                            )} 

                                            {((PERMISSION?.addEdit === 'Y' || PERMISSION?.fullAccess === 'Y') && items?.availableArabianPoints > 0) && (
                                              <Menu.Item key={`2`} onClick={() => { 
                                                setReverseID(items?._id);
                                                toggleConfirmPopup();
                                              }} >
                                                <FontAwesomeIcon icon={faRefresh} /> <span className="show_span">Reverse Amount</span>
                                              </Menu.Item>
                                            )} 
                                            
                                            {(
                                              (items.status === 'I' || items.status === 'B' || items.status === 'D') &&
                                              (PERMISSION?.changeStatus === 'Y' || PERMISSION?.fullAccess === 'Y')
                                            )  && (
                                              <Menu.Item key={`3`} onClick={()=>handleChangeStatus(items._id,'A') } >
                                                <FontAwesomeIcon icon={faThumbsUp} /> <span className="show_span">Active</span>
                                              </Menu.Item>
                                            )}
                                            {(  
                                              items.status === 'A' && 
                                              (PERMISSION?.changeStatus === 'Y' || PERMISSION?.fullAccess === 'Y')
                                             ) && (
                                               <Menu.Item key={`4`} onClick={() => handleChangeStatus(items._id,'I')} >
                                                <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Inactive</span>
                                              </Menu.Item>
                                            )}
                                            {(items.status !== 'D' && (PERMISSION?.delete === 'Y' || PERMISSION?.fullAccess === 'Y')) && (<>
                                              {/* <Menu.Item key={`5`} onClick={() => handleChangeStatus(items._id,'B')} >
                                                <FontAwesomeIcon icon={faBan} /> <span className="show_span">Block</span>
                                              </Menu.Item> */}
                                              <Menu.Item key={`6`} onClick={() => handleChangeStatus(items._id,'D')} >
                                                <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Delete </span>
                                              </Menu.Item>
                                            </>)}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={12} /> : <tr> 
                                <td colspan="11" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                        <p>{`${SKIP + 1} - ${LIMIT * currentPage} of ${totalDataCount}`}</p>
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      <DueAmountUpdatePopup popUpOpen={isDueAmountShow} togglePopUp={handleDueAmountDrawer} getList={getList} />
      <CollectionUpdatePopup popUpOpen={isCollectionShow} togglePopUp={handleCollectionDrawer} getList={getList} />
      <ConfirmPopup popUpOpen={confirmPopup} togglePopUp={toggleConfirmPopup} process={handleAmountReverse} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="bind_with_" className="all_section_for_label_main_class" >
                  Bind with :
                </label>
                <SelectUsers
                  key={filterBindWith?.bind_person_id || 'empty'}
                  setAddEditData={setFilterBindWith}
                  defaultSelect={filterBindWith._id ? {
                      label: `${filterBindWith.bind_person_name}  | ${filterBindWith.bind_person_mobile}`,
                      value: JSON.stringify({
                          _id: filterBindWith.bind_person_id,
                          users_name: filterBindWith.users_name,
                          last_name: filterBindWith.last_name,
                          users_mobile: filterBindWith.users_mobile
                      })
                  } : {}} 
                  // user_type={filterBindWith?.bind_user_type || ''}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='users_name' selected={filter?.filter_by ==='users_name'?true:false}>First name</option>
                  <option value='last_name' selected={filter?.filter_by ==='last_name'?true:false}>Last name</option>
                  <option value='users_type' selected={filter?.filter_by ==='users_type'?true:false}>User Type</option>
                  <option value='area' selected={filter?.filter_by ==='area'?true:false}>Area</option>
                  <option value='pos_number' selected={filter?.filter_by ==='pos_number'?true:false}>POS number</option>
                  {/* <option value='pos_device_id' selected={filter?.filter_by ==='pos_device_id'?true:false}>POS Device ID</option> */}
                  <option value='pos_serial_id' selected={filter?.filter_by ==='pos_serial_id'?true:false}>POS Serial ID</option>
                  <option value='store_name' selected={filter?.filter_by ==='store_name'?true:false}>Store name</option>
                  <option value='users_mobile' selected={filter?.filter_by ==='users_mobile'?true:false}>Mobile</option>
                  <option value='users_email' selected={filter?.filter_by ==='users_email'?true:false}>Email</option>
                  <option value='bind_user_type' selected={filter?.filter_by ==='bind_user_type'?true:false}>Bind with user's type</option>
                  <option value='plateform' selected={filter?.filter_by ==='plateform'?true:false}>Platform</option>
                  <option value='status' selected={filter?.filter_by ==='status'?true:false}>Status</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
